import * as tslib_1 from "tslib";
import { Component } from "vue-property-decorator";
import { Icon, Tooltip } from "@h3/antd-vue";
import { SystemControl } from "../../controls";
let PcSystemControl = class PcSystemControl extends SystemControl {
};
PcSystemControl = tslib_1.__decorate([
    Component({
        name: "system-control",
        components: {
            AIcon: Icon,
            ATooltip: Tooltip
        }
    })
], PcSystemControl);
export default PcSystemControl;
